/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{flex:auto;display:flex}[_nghost-%COMP%]   .btn-edit-schedule[_ngcontent-%COMP%]{float:right;margin-right:3px}dx-box[_ngcontent-%COMP%], dx-data-grid[_ngcontent-%COMP%]{flex:auto}.fa-exclamation-triangle[_ngcontent-%COMP%]{color:red;float:left}.cell-warning[_ngcontent-%COMP%]{background-color:rgba(255,69,0,.5)}kendo-splitter[_ngcontent-%COMP%]{flex:auto;width:100%;height:100%}"];
export { styles as styles };
